<template>
  <!-- element ui的隐藏组件滚动条 -->
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <div style="background-color:rgb(255, 255, 255);height:50px;padding-top: 3px;"><logo/></div>
    <el-menu
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      mode="vertical"
      background-color="#15263F"
      text-color="#bfcbd9"
      active-text-color="#409EFF">
      <sidebar-item v-for="route in permission_routers" :key="route.name" :item="route" :base-path="route.path"/>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import SidebarItem from './SidebarItem'
import { mapGetters } from 'vuex'
import Logo from '@/components/Logo'
export default {
  components: { SidebarItem, Logo },
  data() {
    return {
      menuList: [null],
      menuRoute: []
    }
  },
  computed: {
    ...mapGetters([
      'permission_routers',
      'sidebar'
    ]),
    // 是否折叠或者展开 最新版本的样式中 打开其他的时候自动合上菜单
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/menu/components/Sidebar/index.vue